export default "__VITE_ASSET__cvUo0HMs__"